import { NavLink } from 'react-router-dom'
import { Users, Home, BarChart3, Settings, ChevronLeft } from 'lucide-react'

const navItems = [
  { path: '/admin', label: 'Dashboard', icon: BarChart3, exact: true },
  { path: '/admin/users', label: 'Users', icon: Users },
]

const AdminSidebar = () => {
  return (
    <aside className="w-64 bg-dark-900 border-r border-dark-700 min-h-screen flex flex-col">
      {/* Header */}
      <div className="p-4 border-b border-dark-700">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-accent-500/20 rounded-lg">
            <Settings className="w-5 h-5 text-accent-400" />
          </div>
          <div>
            <h2 className="font-semibold text-lg">Admin Panel</h2>
            <p className="text-sm text-dark-400">Voxerface</p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4">
        <ul className="space-y-1">
          {navItems.map(({ path, label, icon: Icon, exact }) => (
            <li key={path}>
              <NavLink
                to={path}
                end={exact}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2 rounded-lg transition-colors ${
                    isActive
                      ? 'bg-accent-500/20 text-accent-400'
                      : 'text-dark-300 hover:bg-dark-800 hover:text-dark-100'
                  }`
                }
              >
                <Icon className="w-5 h-5" />
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-dark-700">
        <NavLink
          to="/"
          className="flex items-center gap-2 px-3 py-2 text-dark-400 hover:text-dark-200 transition-colors"
        >
          <ChevronLeft className="w-4 h-4" />
          Back to Site
        </NavLink>
      </div>
    </aside>
  )
}

export default AdminSidebar
